import styled from 'styled-components'
import { media } from '../theme'

const Container = styled.div`
  align-items: center;
  background-attachment: fixed;
  background: linear-gradient(to bottom, #264554, #3ea9b4);
  color: #fff;
  display: flex;
  flex-direction: column;
  font-family: ${p => p.theme.fontFamily.primary};
  justify-content: center;
  min-height: 100%;
  overflow: hidden;
  padding: ${p => p.theme.spacing(1)};
  padding-bottom: calc(${p => p.theme.spacing(1)} + ${p => p.theme.spacing(4)});
  position: relative;

  @media (min-height: 650px) and (min-width: ${p =>
      p.theme.mediaSizes.medium}px) {
    background: linear-gradient(to right, #76ced9, #0a9ca6);
    padding: ${p => p.theme.spacing(3)} ${p => p.theme.spacing(1)};
    padding-bottom: calc(
      ${p => p.theme.spacing(3)} + ${p => p.theme.spacing(6)}
    );
  }
`

export default Container



// WEBPACK FOOTER //
// ./src/components/Container.js